import { Box, Typography } from '@mui/material';

export const RegistrationContactFooter = () => (
  <Typography
    variant='caption'
    sx={{ mt: 2, color: 'common.white', textAlign: 'center', width: { xs: '100%', md: '350px' }, display: 'block' }}
  >
    If you need assistance with registration, please contact{' '}
    <Box
      component='a'
      href='mailto:service@lioinsurance.com'
      sx={{
        color: 'secondary.main',
        textDecoration: 'none',
        fontWeight: 'bold',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      service@lioinsurance.com
    </Box>{' '}
    or call
    <Box component='span' sx={{ fontWeight: 'bold' }}>
      {' '}
      (877) 546-7155.
    </Box>
  </Typography>
);
